import React, { useCallback } from 'react';
import { useNavigation, useRoute } from '@react-navigation/native';

import ServiceNoteButton from '../driver/components/ServiceNoteButton';
import { ROLE_PERMISSIONS } from '../../../common/constants';
import { useUserContext } from '../../../common/utils/context';
import { GET_TICKET_LIST_DETAIL } from '../../../common/graphql/ticketList';
import { Spinner } from '../../components';
import { Screen } from '../../design/components';
import { useFreshDetailQueryOptions } from '../../hooks';
import { useOfflineQueue } from '../../offline';
import TicketListDetail from './TicketListDetail';
import TrainingModeBanner from '../myDay/TrainingModeBanner';
import { getMyDayTrainingRouteParams, isMyDayTraining } from '../myDay/myDayTraining';

const TicketListDetailView = () => {

	const navigation = useNavigation();
	const route = useRoute();
	const { hasPermission } = useUserContext();
	const { isOnline } = useOfflineQueue();
	const id = route.params?.id;
	const trainingContext = route.params?.myDayTraining;
	const isTraining = isMyDayTraining(trainingContext);
	const canAddTickets = Boolean(hasPermission?.(ROLE_PERMISSIONS.ADD_EDIT_TICKETS));
	const {
		canRenderDetailQuery,
		detailQueryOptions,
		blockDataWhileLoading,
	} = useFreshDetailQueryOptions({ noCache: isTraining });

	const openTicketCreator = useCallback(() => {
		navigation.push('TicketCreator', {
			machineId: route.params?.machineId,
			machineName: route.params?.machineName,
			docketId: route.params?.docketId,
			...getMyDayTrainingRouteParams(route.params?.myDayTraining),
		});
	}, [navigation, route.params?.docketId, route.params?.machineId, route.params?.machineName, route.params?.myDayTraining]);

	return (
		<Screen
			headerRight={<ServiceNoteButton />}
			scroll={false}
			banner={<TrainingModeBanner trainingContext={trainingContext} isOnline={isOnline} />}
		>
			{canRenderDetailQuery ? (
				<TicketListDetail
					id={id}
					query={GET_TICKET_LIST_DETAIL}
					machineName={route.params?.machineName}
					detailQueryOptions={detailQueryOptions}
					blockDataWhileLoading={blockDataWhileLoading}
					trainingContext={trainingContext}
					serviceDocketId={route.params?.docketId}
					onCreateTicket={canAddTickets ? openTicketCreator : undefined}
				/>
			) : <Spinner />}
		</Screen>
	);
};

export default TicketListDetailView;
